<template>
	<div id="home">
		<!-- 顶部信息 -->
		<shortcut-bar ref="homeHeader" class="home-header" />
		<div class="home-header-placeholder"></div>
		<!-- 商品、购物车、订单 -->
		<!-- <div class="topBar">
			<div class="topBar-box" @click="onCommodity">
				<img src="../../../static/images/icon/icon15.png" alt="">
				<div>{{ $t('商品') }}</div>
			</div>
			<div class="topBar-box" @click="myOrder">
				<img src="../../../static/images/icon/icon16.png" alt="">
				<div>{{ $t('我的订单') }}</div>
			</div>
			<div class="topBar-box" @click="onCart">
				<img src="../../../static/images/icon/icon17.png" alt="">
				<div>{{ $t('购物车') }}</div>
			</div>
		</div> -->
		<!-- 轮播图 -->
		<div ref="homeBanner" class="tw-pt-6 md:tw-pt-12">
			<main-view />
		</div>
		<!-- 首页内容统一使用固定 PC 宽度，浏览器缩放时不随视口重新排版。 -->
		<div class="home-content">
			<!-- 公告 -->
			<div ref="homeNotice" class="announcement">
				<div class="announcement-tit">{{ $t('公告') }}</div>
				<div class="announcement-txt" v-html="web_notice"></div>
			</div>
			<!-- 动态 -->
			<div ref="homeClassify">
				<classify-list></classify-list>
			</div>

			<div class="home_center page-gutter">
				<!-- 搜索 -->
				<div ref="homeSearch" class="home-center-search">
					<div class="search-box">
						<div class="search-box-input flex align-center">
							<img src="../../../static/images/icon/icon11.png" alt="">
							<input type="text" :placeholder="$t('请输入您想搜索的内容')" v-model="keyword"
								@keyup.enter="onSearch">
						</div>
						<div class="search-box-btn" @click="onSearch">{{ $t('搜索') }}</div>
					</div>
				</div>
				<!-- 新品专区 -->
				<div ref="homeGoods">
					<goods-list />
				</div>
				<!-- 精选商品 -->
				<div ref="homeChoiceness">
					<choiceness-list></choiceness-list>
				</div>
			</div>
		</div>

		<footer-bar></footer-bar>
	</div>
</template>

<script>
	import MainView from './components/MainView.vue';
	import { getTestData, getconf } from '@/api/user';
	import goodsList from './components/goodsList.vue';
	import ShortcutBar from '@/components/ShortcutBar';
	import footerBar from '@/components/footerBar';
	import classifyList from './components/classifyList.vue';
	import choicenessList from './components/choicenessList.vue';
	import { fadeUp } from '@/plugins/gsap';

	export default {
		name: 'Home',
		components: {
			'main-view': MainView,
			'goods-list': goodsList,
			'shortcut-bar': ShortcutBar,
			'classify-list': classifyList,
			'choiceness-list': choicenessList,
			'footer-bar': footerBar
		},
		data() {
			return {
				isFixedBarShowed: false,
				keyword: '',//搜索内容
				web_notice: '',//公告
				// 首页入场动画实例，用于组件销毁时释放动画资源
				homeEntranceAnimation: null,
				// 页眉入场动画实例，用于组件销毁时释放动画资源
				homeHeaderAnimation: null,
			}
		},
		mounted() {
			var showFixedBar = this.showFixedBar;
			showFixedBar();
			window.onscroll = function () {
				showFixedBar();
			};
			this.getTestList()
			this.onGetconf()
			this.$nextTick(() => {
				this.playHomeHeaderAnimation()
				this.playHomeEntranceAnimation()
			})
		},
		beforeDestroy() {
			if (this.homeHeaderAnimation) {
				this.homeHeaderAnimation.kill()
			}
			if (this.homeEntranceAnimation) {
				this.homeEntranceAnimation.kill()
			}
		},
		methods: {
			/** 播放首页固定页眉的入场动效 */
			playHomeHeaderAnimation() {
				const header = this.$refs.homeHeader && this.$refs.homeHeader.$el
				if (!header || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					return
				}
				this.homeHeaderAnimation = this.$gsap.from(header, {
					y: -20,
					opacity: 0,
					duration: 0.45,
					ease: 'power2.out',
				})
			},
			/** 播放首页各内容区块的依次入场动效 */
			playHomeEntranceAnimation() {
				if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					return
				}
				this.homeEntranceAnimation = fadeUp([
					this.$refs.homeBanner,
					this.$refs.homeNotice,
					this.$refs.homeClassify,
					this.$refs.homeSearch,
					this.$refs.homeGoods,
					this.$refs.homeChoiceness,
				].filter(Boolean), {
					y: 24,
					duration: 0.6,
					stagger: 0.1,
				})
			},
			/**配置信息 */
			onGetconf() {
				getconf({ module: 'system' }).then(res => {
					// console.log(res.data.web_notice);
					this.web_notice = res.data.web_notice
				})
			},
			/**商品 */
			onCommodity() {
				this.$router.push({ name: "Search", params: { keyword: '' } });
			},
			/**购物车 */
			onCart() {
				this.$router.push({ name: 'ShoppingCart', params: { type: 1 } });
			},
			/**我的订单 */
			myOrder() {
				this.$router.push({ name: 'MyOrder2', params: { type: 0 } });
			},
			/**搜索 */
			onSearch() {
				if (this.keyword) {
					this.$router.push({ name: 'Search', params: { keyword: this.keyword } })
				}
			},
			getTestList() {
				return
				getTestData({
					page: 1
				}).then(res => {
					if (res.code == 1) {

					} else {
						this.$message.info(res.data.msg);
					}
				}).catch(err => {

				})
			},
			showFixedBar: function () {
				if (window.pageYOffset < 620) {
					this.isFixedBarShowed = false;
				} else {
					this.isFixedBarShowed = true;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	/*#home .transition {
		width: 100%;
		height: 160px;
		background: url('../assets/app-footer-bg.jpg') no-repeat;
		background-position: 50% 0;
	}*/
	#home {
		background: #FFFFFF;
		width: 100%;
		overflow-x: hidden;
		min-width: 0;
	}

	/* 首页公告、分类、商品等内容区保持与轮播图一致的 PC 栅格宽度。 */
	@media (min-width: 768px) {
		.home-content {
			width: 1280px;
			margin: 0 auto;
			padding-top: 32px;
			box-sizing: border-box;

			/* 内容模块的实际可视宽度与首页轮播图统一为 1280px。 */
			.announcement {
				margin: 0 0 32px;
			}

			.home_center {
				padding-left: 0;
				padding-right: 0;
			}
		}

		/* 子组件的分类模块取消原有页面边距，保持与轮播图同宽。 */
		.home-content>>>.classify {
			margin-left: 0;
			margin-right: 0;
		}
	}

	.home-header {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 999;
		width: 100%;
		padding-top: env(safe-area-inset-top, 0px);
	}

	.home-header-placeholder {
		height: calc(56px + env(safe-area-inset-top, 0px));
	}

	.home_center {
		width: 100%;
		min-width: 0;
		box-sizing: border-box;

		.home-center-search {
			padding: 20px 0 24px;

			@media (min-width: 768px) {
				padding: 56px 16px 56px;
			}

			@media (min-width: 1280px) {
				padding: 72px 28px 70px;
			}

			.search-box {
				width: 100%;
				max-width: 720px;
				margin: 0 auto;
				height: 44px;
				display: flex;
				align-items: center;
				background: #F8F8F8;
				box-sizing: border-box;
				border-radius: 30px;
				overflow: hidden;

				@media (min-width: 768px) {
					height: 52px;
					max-width: none;
				}

				.search-box-input {
					flex: 1;
					min-width: 0;
					height: 100%;
				}

				img {
					width: 20px;
					height: 20px;
					margin-right: 10px;
					margin-left: 14px;
					flex-shrink: 0;

					@media (min-width: 768px) {
						width: 24px;
						height: 24px;
						margin-right: 14px;
						margin-left: 22px;
					}
				}

				.search-box-btn {
					height: 100%;
					background: #000000;
					font-size: 14px;
					color: #FFFFFF;
					padding: 0 16px;
					line-height: 44px;
					border-radius: 30px;
					cursor: pointer;
					white-space: nowrap;
					flex-shrink: 0;

					@media (min-width: 768px) {
						font-size: 18px;
						padding: 0 26px;
						line-height: 52px;
					}
				}

				input {
					background: #F8F8F8;
					width: 100%;
					min-width: 0;
					/* 16px 避免 iOS 聚焦时强制放大 */
					font-size: 16px;

					@media (min-width: 768px) {
						font-size: 18px;
					}
				}
			}
		}
	}

	/**公告 */
	.announcement {
		color: #333333;
		text-align: center;
		padding: 16px 12px;
		background-color: #EFF7ED;
		margin: 16px var(--page-gutter);
		border-radius: 8px;
		box-sizing: border-box;

		@media (min-width: 768px) {
			padding: 34px 16px;
			margin: 32px var(--page-gutter);
		}

		.announcement-tit {
			font-size: 18px;
			margin-bottom: 8px;

			@media (min-width: 768px) {
				font-size: 30px;
				margin-bottom: 21px;
			}
		}

		.announcement-txt {
			font-size: 13px;
			line-height: 1.6;
			padding: 0 4px;
			word-break: break-word;
			text-align: left;

			/* // 公告内容由后台富文本返回，限制媒体尺寸以适配页面宽度。 */
			& /deep/ img,
			& /deep/ video,
			& /deep/ table {
				max-width: 100%;
				height: auto;
			}

			& /deep/ p {
				margin: 0 0 8px;
			}

			& /deep/ p:last-child {
				margin-bottom: 0;
			}

			@media (min-width: 768px) {
				font-size: 20px;
			}
		}
	}

	/**顶部购物车、订单等跳转模块 */
	.topBar {
		padding: 16px var(--page-gutter);
		background-color: #eff7ed;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;

		@media (min-width: 768px) {
			padding: 24px var(--page-gutter);
			gap: 32px;
		}

		.topBar-box {
			flex: 1 1 0;
			min-width: 96px;
			font-size: 14px;
			color: #FFFFFF;
			padding: 14px 8px;
			background: linear-gradient(180deg, #57DD97 0%, #16C76B 100%);
			border-radius: 12px;
			opacity: 0.7;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 0;
			cursor: pointer;

			@media (min-width: 768px) {
				flex: 0 0 230px;
				font-size: 20px;
				padding: 22px 0;
				border-radius: 16px;
			}

			img {
				width: 20px;
				height: 20px;
				margin-right: 8px;

				@media (min-width: 768px) {
					width: 28px;
					height: 28px;
					margin-right: 16px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/home/Home.vue